import { useState, useEffect } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import BusinessIcon from '@mui/icons-material/Business';
import WindPowerIcon from '@mui/icons-material/WindPower';
import './Dropdown.css';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';


const Dropdowncomp = ({ handleSelectedItem, props }) => {
  /***RESPONSIVENESS */
  const siteName = props.name;
  const buildings = props.buildings;
  const [selectedItem, setSelectedItem] = useState(null);
  const setObject = (entity, id, name) => {
    const obj = {
      type: entity,
      id: id,
      name: name

    }
    handleSelectedItem(obj)
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900); // Adjust the breakpoint as needed
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [isMobile]);

  

  return (
    <div className='cont' style={{ display: 'flex', height: '100vh' }}>
      {isMobile ? (
        <>
          <div className="contentss">
            <button className="sidebar-toggle" onClick={toggleSidebar}>
              {isSidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
            </button>
          </div>
          {isSidebarOpen && (
            <Sidebar className="app">
              <Menu>
                <MenuItem className="menu1">
                  <h4>{siteName}</h4>
                </MenuItem>
                {buildings.map((building, index) => (
                  <SubMenu label={building.name} icon={<BusinessIcon />} onClick={() => {
                    setObject("building", building.id, building.name)

                  }} >
                    {building.assets.map((asset, index1) => (
                      <>
                        <SubMenu label={asset.name} icon={<WindPowerIcon />} onClick={() => {
                          setObject("asset", asset.id, asset.name)

                        }}   >
                          {asset.items.map((item, index2) => (
                            <Tooltip title={item.serialNumber} arrow>
                            <MenuItem onClick={() => {
                              setObject("item", item.id, item.serialNumber)

                            }}> 
                            {item.serialNumber} 
                            </MenuItem>
                            </Tooltip>
                          ))}
                        </SubMenu>
                      </>
                    ))}
                  </SubMenu>
                ))}
              </Menu>
            </Sidebar>
          )}
        </>
      ) : (
        <Sidebar className="app">
          <Menu>
            <MenuItem className="menu1">
              <h4>{siteName}</h4>
            </MenuItem>


            {buildings.map((building, index) => (
              <Tooltip title={building.name} followCursor placement="top" TransitionComponent={Zoom} enterDelay={400} enterTouchDelay={0} leaveTouchDelay={4000}>
              <SubMenu label={building.name} icon={<BusinessIcon />} 
              className={selectedItem === building.id ? 'selected-item' : ''}
              onClick={() => {
                setSelectedItem(building.id);
                setObject("building", building.id, building.name)

              }} >
                {building.assets.map((asset, index1) =>
                  <> 
                  <Tooltip title={asset.name} followCursor placement="top" TransitionComponent={Zoom} enterDelay={400}>
                  <SubMenu label={asset.name} icon={<WindPowerIcon />} className={selectedItem === asset.id ? 'selected-item' : ''}
              
                  onClick={() => {
                    setSelectedItem(asset.id);
                    setObject("asset", asset.id, asset.name)

                  }}   >

                    {asset.items.map((item, index2) =>
                      <>
                      <Tooltip title={item.serialNumber} followCursor placement="top" TransitionComponent={Zoom} enterDelay={400}>
                      <MenuItem className={selectedItem === item.id ? 'selected-item' : ''}
                      onClick={() => {
                        setSelectedItem(item.id);
                        setObject("item", item.id, item.serialNumber)

                      }}> {item.serialNumber} </MenuItem>
                      </Tooltip>
                      </>

                    )}
                  </SubMenu>
                  </Tooltip>
                  </>

                )}
              </SubMenu>
              </Tooltip>

            ))}

          </Menu>
        </Sidebar>
      )}
    </div>
  );
};
export default Dropdowncomp;
